import { createApiAction } from '@app/packages/api/utils'
import type { ApiFaq } from '@app/packages/api/v2/types/entities'
import type { FaqFilter } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getFaq = (filter?: FaqFilter) =>
  createApiAction('getFaq', dispatch => dispatch<{ data: ApiFaq }>({ method: 'GET', endpoint: v2Path('/api/v2/faq', filter) }))
